module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#share",
      toString: function () {
        return this.url;
      }
    }